import styled from "@emotion/styled";
import * as React from "react";
import { Link } from "react-router-dom";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import Text from "components/layout/Text";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { IMergedTicket } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IChildTicketOptionProps {
  ticket: IMergedTicket;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 780px;
  margin: 0 60px;
  box-sizing: border-box;
  justify-content: space-between;
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  padding: 12px 0 14px;
  &:hover {
    background: ${withVar(DesignToken.SurfacePrimaryHover)};
  }
`;

const StyledLink = styled(Link)`
  font-weight: normal;
  cursor: pointer;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.linkColor
  };
  text-decoration: none;
  margin-right: 5px;
`;

const EmptySubject = styled.span`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor50
  };
`;

const Group = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${Text}, ${StyledLink} {
    margin-right: 5px;
  }
`;

export const ChildTicketOption: React.FC<IChildTicketOptionProps> = props => {
  const { ticket } = props;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  const handleChildClick = (e: any) => {
    e.stopPropagation();
    trackEngagement("Merging tickets: ticket child link clicked", EventPlace.Tickets);
  };

  return (
    <Wrapper>
      <Group data-testid={`ticket-event-child-ticket-${ticket.ID}`}>
        <Icon name={IconsEnum.ChildTicket} width="20px" height="20px" fill="none" />
        <StyledLink to={`/tickets/${ticket.ID}`} onClick={handleChildClick}>
          {ticket.subject || <EmptySubject>No subject</EmptySubject>}
        </StyledLink>
        <Text fontSize="14px">{ticket.shortID}</Text>
      </Group>
    </Wrapper>
  );
};
